import React, { useState } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { programLink } from '~shared/utils/program-link'
import { Program } from '~shared/api/categories/types'
import { cn } from '~shared/utils/cn'

export const RelatedCourses = ({
  programs
}: {
  programs: Program[] | null
}) => {
  return (
    
      <div
        className={cn(
          'flex-col items-start gap-6 rounded-[16px]',
          'bg-[var(--omega)] text-[var(--alpha)]',
          'flex w-full p-8 mt-[64px]'
        )}>
        <p className='text-sm leading-snug mb-2'>
          Важно! Мы настоятельно рекомендуем ознакомиться с нашими программами,
          где тема данной статьи раскрывается более подробно
        </p>

        {programs?.map((program, idx) => (
          <React.Fragment key={program?.slug}>
            <div
              className={cn(
                'flex gap-[24px] lg:gap-[64px] text-white  justify-between w-full',
                'flex-col md:flex-row'
              )}>
              <div className='flex gap-[16px]'>
                <Image
                  src={program?.image?.url ?? ''}
                  width={100}
                  height={100}
                  alt={program?.image?.alternativeText??'МИТМ фото курса'}
                  quality={80}
                  className='object-cover rounded-[16px] w-[100px] max-h-[100px]'
                />
                <div className={cn('flex gap-4 w-full items-start flex-col')}>
                  <span className='block'>{program.name}</span>
                  {program?.relatedArticleDescription && (
                    <span className='block mt-2 text-[12px]/[120%] md:text-[16px] text-[#a8a8a8]'>
                      {program.relatedArticleDescription}
                    </span>
                  )}
                </div>
              </div>

              <Link
                href={programLink(program)}
                className={cn(
                  'text-white hover:bg-white text-[14px] bg-accent rounded-[16px] w-full md:min-w-[150px] md:max-w-[150px] h-[55px] self-end',
                  'flex items-center justify-center hover:text-accent text-center'
                )}>
                Узнать больше
              </Link>
            </div>
            {idx === 0 && programs.length > 1 && (
              <hr className='w-full border-t border-[#585858] mt-2' />
            )}
          </React.Fragment>
        ))}

        <span className='text-[13px]/[150%] font-medium tracking-[0.4px] text-[#8B8B8B] mt-4'>
          Спешите записаться на обучение, количество мест ограничено
        </span>
      </div>
  )
}
